// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
// 在 main.js 中以 vue 插件的形式引入 axios，这样在其他地方就可通过 this.$api 调用相关的接口了。
import api from './http/index'
import './permission' // 路由
// import VueAMap from 'vue-amap'
Vue.config.productionTip = false
Vue.use(api)
Vue.use(Antd)
// Vue.use(VueAMap)

// VueAMap.initAMapApiLoader({
//   // 高德key
//   key: '3b40534c5d1afca7fe7f626110f7e094', // 高德地图key
//   securityJsCode: '8de130aceb79d704220d0d9d1593ef83',
//   // 插件集合 （插件按需引入）
//   plugin: [
//     'AMap.Autocomplete',
//     'AMap.PlaceSearch',
//     'AMap.Scale',
//     'AMap.OverView',
//     'AMap.ToolBar',
//     'AMap.MapType',
//     'AMap.PolyEditor',
//     'AMap.CircleEditor',
//     'AMap.MarkerClusterer',
//     'AMap.Geocoder'
//   ],
//   v: '1.4.15' // 我也不知道为什么要写这个，不写项目会报错，而且我随便写的，跟我下载的版本对应不了
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js